<rt-form-field [required]="!control().value.length">
  <rt-label>{{ 'app.interview.schedule_dialog.request_from' | translate }}</rt-label>

  <div layout>
    <rt-admins-avatars
      [admins]="control().value"
      [editable]="editable()"
      [limit]="5"
      (addClick)="editAssignments.emit()"
      (avatarsClick)="editAssignments.emit()"
      variant="rtl"
      margin-top-small-x
    />
  </div>
</rt-form-field>
